module.exports = __webpack_public_path__ + "media/7-z.e9bc07a3.wav";